import React from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import {FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter, FaYoutube} from 'react-icons/fa';
import reactHtmlParser from "react-html-parser";


const Footer = ({data}) => {
    const d = new Date();

    let year = d.getFullYear();

    // api data refactor
    let rowData = data && data?.data;
    return (
        <StyledFooter className='footer'>
            <Container className='footer__top'>
                <Row>
                    <Col className={'group logo'}>
                        <Link to={'/'}>
                            <svg id="Group_21239" data-name="Group 21239" xmlns="http://www.w3.org/2000/svg"
                                 xmlnsxlink="http://www.w3.org/1999/xlink" width="65.498" height="80"
                                 viewBox="0 0 65.498 80">
                                <defs>
                                    <clipPath id="clip-path">
                                        <rect id="Rectangle_5842" data-name="Rectangle 5842" width="65.498" height="80"
                                              fill="none"/>
                                    </clipPath>
                                </defs>
                                <g id="Group_20865" data-name="Group 20865">
                                    <path id="Path_8656" data-name="Path 8656"
                                          d="M125.088,19.436c-.33-.586-1.347.087-1.347.087a68.744,68.744,0,0,0-9.7,1.128,30.473,30.473,0,0,0,8.206-9.7c.879-.254,1.092-.761.759-1.119-.449-.533-1.279.358-1.279.358a66,66,0,0,0-11.192,3.969,28.39,28.39,0,0,0,3.906-9.6c.759-.446.842-.994.421-1.263-.588-.372-1.14.669-1.14.669A64.726,64.726,0,0,0,106.4,8.789a37.049,37.049,0,0,0-3.021-6.884c.464-1.253,0-1.94-.775-1.9-1.112.074-.7,1.83-.7,1.83-.891,2.246-1.649,4.363-2.286,6.38a31.674,31.674,0,0,0-8.94-4.565c-.369-.793-.92-.936-1.277-.568-.476.491.552,1.157.552,1.157a57.4,57.4,0,0,0,5.8,10.157,33.586,33.586,0,0,0-12.576-3.9c-.546-.677-1.127-.707-1.382-.289-.362.582.8,1.02.8,1.02a61.147,61.147,0,0,0,7.963,8.583,32.7,32.7,0,0,0-10.1-.848c-.679-.577-1.248-.5-1.421-.047-.231.641,1,.868,1,.868a54.571,54.571,0,0,0,13.819,9.4,8.061,8.061,0,0,1,3.323-2.045l.308-.7a13.588,13.588,0,0,1,3.71,2.667v5.271c-2.226-1.417-6.44-3.68-9.607-3.068-1.3.263-13.186,1.7-9.6,15.654.814,3.161,5.151,10.721,17.636,20.054.677.515,2.558,2.351,2.883,3.535.31-1.184,2.2-3.02,2.885-3.535,12.472-9.333,16.816-16.893,17.63-20.054,3.589-13.952-8.3-15.39-9.59-15.654-3.216-.612-7.453,1.69-9.664,3.1V29.178a9.944,9.944,0,0,1,2.941-2.076l.237.532a10.707,10.707,0,0,1,3.236,2.042,32.7,32.7,0,0,0,13.9-9.309c.914-.045,1.234-.5,1.008-.931M96.128,25.879,81.475,19.987c4.444-1.12,14.24,2.517,14.895,2.781-.2,1.786-.243,2.871-.243,3.111m.379-4.126h-.019s.019,0,.019-.013Zm.3-2.051L83.967,11.678c3.959-.292,11.139,3.563,13.436,4.882-.238,1.127-.435,2.185-.594,3.142m1.646-7.516L91.171,4.969c2.388.338,5.531,2.392,8.1,4.362-.3.985-.583,1.937-.813,2.855m22.329-.949c-1.3,4.323-10.188,10.669-10.188,10.669a8.63,8.63,0,0,0-1.787-.822c-.024-.52-.068-1.035-.113-1.53Zm-7.662-6.013c-.017,2.8-2.627,7.093-4.618,9.925a3.23,3.23,0,0,1-.384.219c-.222-1.157-.469-2.254-.742-3.3ZM104.9,48.531a2.355,2.355,0,0,1-4.7,0,2.189,2.189,0,0,1,.992-1.8v-10.8h2.576V46.643a2.178,2.178,0,0,1,1.132,1.888m-2.464-19.956V3.9c4.535,5.433,4.831,21.6,4.831,21.6a12.142,12.142,0,0,0-4.831,3.072m7.714.086a8.224,8.224,0,0,0-2.919-1.83c.9-.458,1.609-.742,1.609-.742v-.123l13.742-5.6c-2.272,3.932-12.432,8.294-12.432,8.294"
                                          transform="translate(-70.108 0)" fill="#e50019"/>
                                    <path id="Path_8657" data-name="Path 8657"
                                          d="M3.7,332.1l-.156.848,3.383.8a37.773,37.773,0,0,0-3.726,1.1l-.149.808,5.238.783.132-.707-3.43-.6q1.879-.6,3.721-.988l.113-.677Z"
                                          transform="translate(-2.707 -294.71)" fill="#1a1818"/>
                                    <path id="Path_8658" data-name="Path 8658"
                                          d="M3.721,375.067a1.528,1.528,0,0,0,.428-.413,1.052,1.052,0,0,0,.167-.486,1.272,1.272,0,0,0-.523-1.039,2.833,2.833,0,0,0-1.454-.595,2.175,2.175,0,0,0-1.484.293A1.333,1.333,0,0,0,.2,373.879a1.181,1.181,0,0,0,.088.538,1.572,1.572,0,0,0,.369.508l-.414-.014-.049.834,3.91.076.049-.735Zm-.671-.236a1.392,1.392,0,0,1-.847.2,1.317,1.317,0,0,1-.824-.287.781.781,0,0,1-.286-.657.75.75,0,0,1,.361-.595,1.312,1.312,0,0,1,.848-.174,1.51,1.51,0,0,1,.807.314.741.741,0,0,1,.284.617.722.722,0,0,1-.344.58"
                                          transform="translate(-0.174 -330.576)" fill="#1a1818"/>
                                    <path id="Path_8659" data-name="Path 8659"
                                          d="M3.915,406.317l0-.376-.848,0,.006.387L0,406.358l.042.833,3.062-.1.022.448.843-.041-.021-.435,1.445-.052-.036-.7Z"
                                          transform="translate(0 -360.239)" fill="#1a1818"/>
                                    <path id="Path_8660" data-name="Path 8660"
                                          d="M6.038,421.265a.731.731,0,0,0-.445-.107.759.759,0,0,0-.452.164.414.414,0,0,0-.173.341.379.379,0,0,0,.2.313.73.73,0,0,0,.457.087.741.741,0,0,0,.444-.165.4.4,0,0,0,.172-.327.369.369,0,0,0-.2-.306m-5.331.284.042.834,3.9-.331-.034-.735Z"
                                          transform="translate(-0.627 -373.744)" fill="#1a1818"/>
                                    <path id="Path_8661" data-name="Path 8661"
                                          d="M5.873,435.822a2.42,2.42,0,0,0-1.6-.354,2.067,2.067,0,0,0-1.377.651,1.49,1.49,0,0,0-.422,1.285,1.55,1.55,0,0,0,.4.834,1.648,1.648,0,0,0,.836.477,2.258,2.258,0,0,0,1.05.008,2.618,2.618,0,0,0,.968-.422,2.052,2.052,0,0,0,.659-.723,1.349,1.349,0,0,0,.159-.816,1.334,1.334,0,0,0-.675-.941m-.464,1.74a1.414,1.414,0,0,1-.771.379,1.24,1.24,0,0,1-.848-.1.755.755,0,0,1-.4-.579.741.741,0,0,1,.218-.667,1.249,1.249,0,0,1,.783-.353,1.368,1.368,0,0,1,.843.127.735.735,0,0,1,.4.541.746.746,0,0,1-.227.647"
                                          transform="translate(-2.183 -386.431)" fill="#1a1818"/>
                                    <path id="Path_8662" data-name="Path 8662"
                                          d="M7.251,466.928l.2.813,1.526-.4a6.93,6.93,0,0,1,.777-.175,1.23,1.23,0,0,1,.594.088.475.475,0,0,1,.285.328.449.449,0,0,1-.048.323.654.654,0,0,1-.3.266,5.443,5.443,0,0,1-.881.319L7.763,469l.226.8,2.463-.826a1.752,1.752,0,0,0,.885-.568.96.96,0,0,0,.212-.839.788.788,0,0,0-.2-.373,1.864,1.864,0,0,0-.492-.35l.392-.1-.18-.721Z"
                                          transform="translate(-6.435 -413.56)" fill="#1a1818"/>
                                    <path id="Path_8663" data-name="Path 8663"
                                          d="M22.606,499.368a2.016,2.016,0,0,0,.2-.554.938.938,0,0,0-.042-.524,1.119,1.119,0,0,0-.863-.708,2.559,2.559,0,0,0-1.543.116,2.288,2.288,0,0,0-1.228.927,1.436,1.436,0,0,0-.184,1.263,1.164,1.164,0,0,0,.292.458,1.324,1.324,0,0,0,.544.294l-.385.166.351.756,3.56-1.711L23,499.189Zm-.722.1a1.374,1.374,0,0,1-.659.553,1.348,1.348,0,0,1-.879.128.7.7,0,0,1-.5-.472.777.777,0,0,1,.094-.712,1.357,1.357,0,0,1,.7-.537,1.3,1.3,0,0,1,.855-.075.657.657,0,0,1,.488.427.808.808,0,0,1-.094.688"
                                          transform="translate(-16.751 -441.503)" fill="#1a1818"/>
                                    <path id="Path_8664" data-name="Path 8664"
                                          d="M29.462,520.019l.35.752,4.813-2.6-.286-.63Z"
                                          transform="translate(-26.146 -459.273)" fill="#1a1818"/>
                                    <path id="Path_8665" data-name="Path 8665"
                                          d="M43.627,543.436l.44.744,1.942-1.324a10.925,10.925,0,0,0,.77,1.145L44.9,545.417l.5.693,4.207-3.341-.414-.582-1.621,1.22a11.038,11.038,0,0,1-.746-1.106l1.666-1.145-.362-.625Z"
                                          transform="translate(-38.716 -479.679)" fill="#1a1818"/>
                                    <path id="Path_8666" data-name="Path 8666"
                                          d="M71.789,582.141a2.868,2.868,0,0,0,.831-1.464,1.415,1.415,0,0,0-.3-1.263A1.314,1.314,0,0,0,71.165,579a2.684,2.684,0,0,0-2.27,1.948,1.516,1.516,0,0,0,.373,1.343,1.672,1.672,0,0,0,.717.5,1.61,1.61,0,0,0,.879,0L70.7,582a.928.928,0,0,1-.8-.311.872.872,0,0,1-.221-.637,1.179,1.179,0,0,1,.316-.667l1.656,1.9ZM70.622,579.9a1.484,1.484,0,0,1,.567-.137.746.746,0,0,1,.534.255.731.731,0,0,1,.178.528,1.177,1.177,0,0,1-.195.6Z"
                                          transform="translate(-61.109 -513.811)" fill="#1a1818"/>
                                    <path id="Path_8667" data-name="Path 8667"
                                          d="M95.494,603.05a1.632,1.632,0,0,0-.047-.606.943.943,0,0,0-.268-.436,1.112,1.112,0,0,0-1.092-.22,2.757,2.757,0,0,0-1.333.821,2.425,2.425,0,0,0-.7,1.4,1.39,1.39,0,0,0,.391,1.2,1.124,1.124,0,0,0,.464.26,1.476,1.476,0,0,0,.606.018l-.275.333.618.532,2.462-3.171-.546-.473Zm-.593.416a1.5,1.5,0,0,1-.367.817,1.284,1.284,0,0,1-.72.5.68.68,0,0,1-.663-.17.8.8,0,0,1-.227-.678,1.642,1.642,0,0,1,1.127-1.268.643.643,0,0,1,.636.149.761.761,0,0,1,.214.651"
                                          transform="translate(-81.682 -533.996)" fill="#1a1818"/>
                                    <path id="Path_8668" data-name="Path 8668"
                                          d="M112.632,620.845l.635.494.937-1.33.114-.157a3.435,3.435,0,0,1,.745-.854c.174-.112.3-.131.4-.06a.471.471,0,0,1,.113.2l.666-.581a.522.522,0,0,0-.172-.259.481.481,0,0,0-.373-.1,1.108,1.108,0,0,0-.475.205l.3-.41-.486-.377Z"
                                          transform="translate(-99.952 -548.088)" fill="#1a1818"/>
                                    <path id="Path_8669" data-name="Path 8669"
                                          d="M130.575,618.568l-.291-.224-.48.722.3.232-1.713,2.654.688.436,1.65-2.7.366.232.448-.752-.363-.224.777-1.266-.576-.363Z"
                                          transform="translate(-113.938 -547.822)" fill="#1a1818"/>
                                    <path id="Path_8670" data-name="Path 8670"
                                          d="M155.117,636.513l.742.376,1.056-2.23,1.111.564.391-.922-1.073-.541.425-.9,1.04.529.405-.935-1.628-.819Z"
                                          transform="translate(-137.654 -560.528)" fill="#1a1818"/>
                                    <path id="Path_8671" data-name="Path 8671"
                                          d="M182.428,655.753a2.563,2.563,0,0,0-1.062,1.271,2.3,2.3,0,0,0-.125,1.577,1.465,1.465,0,0,0,.879,1.006,1.413,1.413,0,0,0,.9.043,1.677,1.677,0,0,0,.807-.531,2.479,2.479,0,0,0,.508-.962,2.793,2.793,0,0,0,.114-1.08,2.088,2.088,0,0,0-.284-.949,1.253,1.253,0,0,0-.616-.547,1.229,1.229,0,0,0-1.117.172m1.24,1.251a1.541,1.541,0,0,1-.052.89,1.366,1.366,0,0,1-.489.729.692.692,0,0,1-.681.093.722.722,0,0,1-.457-.528,1.427,1.427,0,0,1,.082-.884,1.484,1.484,0,0,1,.517-.7.7.7,0,0,1,.647-.115.73.73,0,0,1,.433.518"
                                          transform="translate(-160.759 -581.716)" fill="#1a1818"/>
                                    <path id="Path_8672" data-name="Path 8672"
                                          d="M213.347,664.751a6.708,6.708,0,0,0-.276,1.324,1.629,1.629,0,0,0,.227.923,1.247,1.247,0,0,0,.754.507,1.2,1.2,0,0,0,.831-.039,1.4,1.4,0,0,0,.6-.612,5.575,5.575,0,0,0,.4-1.418l.321-1.7a5.5,5.5,0,0,1-.691-.161l-.414,1.948a4.37,4.37,0,0,1-.2.727.652.652,0,0,1-.279.287.432.432,0,0,1-.344.039.506.506,0,0,1-.29-.206.714.714,0,0,1-.108-.384,3.752,3.752,0,0,1,.143-.79l.473-1.9-.693-.18Z"
                                          transform="translate(-189.083 -588.469)" fill="#1a1818"/>
                                    <path id="Path_8673" data-name="Path 8673"
                                          d="M241.231,673.621l.8.133.219-1.624a6.969,6.969,0,0,1,.15-.811,1.284,1.284,0,0,1,.3-.539.431.431,0,0,1,.4-.138.377.377,0,0,1,.268.169.706.706,0,0,1,.118.385,6.643,6.643,0,0,1-.04.97l-.186,1.78c.26.047.524.034.79.059l.213-2.685a1.836,1.836,0,0,0-.166-1.077,1,1,0,0,0-.663-.5.8.8,0,0,0-.408.052,1.9,1.9,0,0,0-.488.332l.054-.406-.7-.114Z"
                                          transform="translate(-214.074 -594.223)" fill="#1a1818"/>
                                    <path id="Path_8674" data-name="Path 8674"
                                          d="M275.241,661.3a1.4,1.4,0,0,0-.419-.392.943.943,0,0,0-.473-.17,1.1,1.1,0,0,0-.963.549,2.893,2.893,0,0,0-.486,1.529,2.384,2.384,0,0,0,.358,1.543,1.281,1.281,0,0,0,1.037.665,1.03,1.03,0,0,0,.524-.092,1.7,1.7,0,0,0,.462-.431l.006.431.8-.041-.2-5.648-.67.035Zm-.186.732a1.712,1.712,0,0,1,.011,1.739.654.654,0,0,1-.611.326.742.742,0,0,1-.594-.372,1.443,1.443,0,0,1-.2-.883,1.518,1.518,0,0,1,.251-.847.681.681,0,0,1,.577-.306.775.775,0,0,1,.57.343"
                                          transform="translate(-242.17 -585.025)" fill="#1a1818"/>
                                    <path id="Path_8675" data-name="Path 8675"
                                          d="M308.291,670.629a1.29,1.29,0,0,0-.462-.345.787.787,0,0,0-.481-.063,1.1,1.1,0,0,0-.9.648,2.914,2.914,0,0,0-.307,1.572,2.451,2.451,0,0,0,.534,1.5,1.292,1.292,0,0,0,1.114.547,1.182,1.182,0,0,0,.493-.2,1.666,1.666,0,0,0,.415-.483l.055.429.794-.125-.616-4.026-.7.109Zm-.1.743a1.431,1.431,0,0,1,.331.818,1.4,1.4,0,0,1-.124.913.759.759,0,0,1-.562.429.679.679,0,0,1-.63-.286,1.491,1.491,0,0,1-.31-.86,1.519,1.519,0,0,1,.155-.866.731.731,0,0,1,.535-.386.654.654,0,0,1,.6.237"
                                          transform="translate(-271.674 -594.638)" fill="#1a1818"/>
                                    <path id="Path_8676" data-name="Path 8676"
                                          d="M335.152,656.263l-.363.052.142.871.375-.063.565,3.152.794-.163-.641-3.122.414-.12-.187-.85-.4.1-.3-1.471-.658.132Z"
                                          transform="translate(-297.1 -580.954)" fill="#1a1818"/>
                                    <path id="Path_8677" data-name="Path 8677"
                                          d="M347.352,650.967a.878.878,0,0,0-.01.481.794.794,0,0,0,.229.429.363.363,0,0,0,.351.108.379.379,0,0,0,.255-.271.754.754,0,0,0,.007-.474.837.837,0,0,0-.238-.43.345.345,0,0,0-.337-.109.386.386,0,0,0-.256.266m1.222,5.419.777-.21-1.008-3.942-.683.183Z"
                                          transform="translate(-308.214 -577.437)" fill="#1a1818"/>
                                    <path id="Path_8678" data-name="Path 8678"
                                          d="M364.772,658.6a2.555,2.555,0,0,0-.058,1.666,2.357,2.357,0,0,0,.865,1.331,1.258,1.258,0,0,0,1.287.2,1.432,1.432,0,0,0,.715-.572,1.87,1.87,0,0,0,.3-.949,2.6,2.6,0,0,0-.185-1.083,2.568,2.568,0,0,0-.57-.914,1.879,1.879,0,0,0-.794-.533,1.116,1.116,0,0,0-.8,0,1.434,1.434,0,0,0-.76.858m1.715.156a1.665,1.665,0,0,1,.559,1.608.774.774,0,0,1-.464.533.682.682,0,0,1-.671-.1,1.331,1.331,0,0,1-.468-.732,1.527,1.527,0,0,1-.029-.893.712.712,0,0,1,.433-.52.625.625,0,0,1,.64.1"
                                          transform="translate(-323.558 -583.635)" fill="#1a1818"/>
                                    <path id="Path_8679" data-name="Path 8679"
                                          d="M391.978,649.412l.723-.366-.647-1.491c-.166-.39-.267-.643-.3-.766a1.463,1.463,0,0,1-.029-.625.518.518,0,0,1,.262-.362.387.387,0,0,1,.307-.017.732.732,0,0,1,.309.254,6.7,6.7,0,0,1,.451.847l.771,1.6.72-.363-1.216-2.377a1.853,1.853,0,0,0-.7-.826.872.872,0,0,0-.834-.057.817.817,0,0,0-.314.284,2.132,2.132,0,0,0-.227.567l-.17-.373-.636.314Z"
                                          transform="translate(-346.491 -572.19)" fill="#1a1818"/>
                                    <path id="Path_8680" data-name="Path 8680"
                                          d="M431.661,623.933a2.547,2.547,0,0,0,.392,1.612,2.259,2.259,0,0,0,1.181,1.023,1.252,1.252,0,0,0,1.306-.162,1.5,1.5,0,0,0,.528-.761,1.991,1.991,0,0,0,.03-1,2.871,2.871,0,0,0-.456-1,2.768,2.768,0,0,0-.8-.707,1.941,1.941,0,0,0-.9-.276,1.118,1.118,0,0,0-.764.237,1.5,1.5,0,0,0-.518,1.035m1.7-.351a1.4,1.4,0,0,1,.663.547,1.356,1.356,0,0,1,.292.839.783.783,0,0,1-.3.656.664.664,0,0,1-.67.1,1.367,1.367,0,0,1-.659-.594,1.429,1.429,0,0,1-.256-.829.811.811,0,0,1,.28-.625.67.67,0,0,1,.647-.094"
                                          transform="translate(-383.054 -552.562)" fill="#1a1818"/>
                                    <path id="Path_8681" data-name="Path 8681"
                                          d="M445.589,599.883l.2-.158,1.94,2.5.61-.543-1.992-2.446.343-.325-.544-.656-.334.316-.314-.39a.464.464,0,0,1-.118-.206.259.259,0,0,1,.088-.178l.222-.128-.5-.581a1.047,1.047,0,0,0-.44.219.708.708,0,0,0-.213.458,1,1,0,0,0,.172.533c.054.078.244.329.564.748l-.2.156Z"
                                          transform="translate(-394.493 -529.87)" fill="#1a1818"/>
                                    <path id="Path_8682" data-name="Path 8682"
                                          d="M467.658,580.789a1.6,1.6,0,0,0,.422-.761,1.394,1.394,0,0,0-.094-.743,1.748,1.748,0,0,0-.5-.685,1.8,1.8,0,0,0-.729-.413,1.419,1.419,0,0,0-.785.023,1.345,1.345,0,0,0-.142-.56,1.5,1.5,0,0,0-.349-.436,1.7,1.7,0,0,0-.743-.4,1.017,1.017,0,0,0-.706.087,2.254,2.254,0,0,0-.557.494l-.385.447,3.752,3.888Zm-3.279-2.947a.463.463,0,0,1,.354-.178.591.591,0,0,1,.374.178.686.686,0,0,1,.224.4.542.542,0,0,1-.159.421l-.106.123-.813-.795Zm1.445,1.469a.9.9,0,0,1,.581-.367.768.768,0,0,1,.536.224.666.666,0,0,1,.231.455,1.136,1.136,0,0,1-.338.628l-.131.154-.991-.971Z"
                                          transform="translate(-410.957 -511.853)" fill="#1a1818"/>
                                    <path id="Path_8683" data-name="Path 8683"
                                          d="M494.6,554.285a1.5,1.5,0,0,0-.569.1,1.036,1.036,0,0,0-.4.316,1.256,1.256,0,0,0-.1,1.156,2.789,2.789,0,0,0,.914,1.308,2.2,2.2,0,0,0,1.406.592,1.278,1.278,0,0,0,1.1-.518,1.3,1.3,0,0,0,.207-.5,1.53,1.53,0,0,0-.04-.627l.337.243.46-.691-3.271-2.255-.4.621Zm.451.576a1.393,1.393,0,0,1,.819.3,1.336,1.336,0,0,1,.548.7.767.767,0,0,1-.1.706.715.715,0,0,1-.625.3,1.3,1.3,0,0,1-.8-.332,1.507,1.507,0,0,1-.522-.714.75.75,0,0,1,.081-.673.7.7,0,0,1,.6-.284"
                                          transform="translate(-437.893 -491.109)" fill="#1a1818"/>
                                    <path id="Path_8684" data-name="Path 8684"
                                          d="M510.739,534.967l.413-.716-1.351-.837a5.808,5.808,0,0,1-.666-.445,1.346,1.346,0,0,1-.361-.49.492.492,0,0,1,.029-.446.385.385,0,0,1,.25-.192.7.7,0,0,1,.391.03,4.992,4.992,0,0,1,.843.416l1.5.848.348-.748-2.3-1.22a1.666,1.666,0,0,0-1.02-.254.939.939,0,0,0-.683.465.782.782,0,0,0-.108.414,1.524,1.524,0,0,0,.108.595l-.343-.21-.375.63Z"
                                          transform="translate(-450.292 -471.135)" fill="#1a1818"/>
                                    <path id="Path_8685" data-name="Path 8685"
                                          d="M524.875,499.068a1.218,1.218,0,0,0-.527.271,1.035,1.035,0,0,0-.292.388,1.18,1.18,0,0,0,.071,1.067,2.524,2.524,0,0,0,1.163,1.069,2.15,2.15,0,0,0,1.484.251,1.375,1.375,0,0,0,.989-.774,1.149,1.149,0,0,0,.089-.559,1.558,1.558,0,0,0-.194-.577,1.934,1.934,0,0,1,.6.337.789.789,0,0,1,.19.4,1.046,1.046,0,0,1-.071.57,1.158,1.158,0,0,1-.267.383.776.776,0,0,1-.369.184l-.386.843a1.827,1.827,0,0,0,.763-.013,1.444,1.444,0,0,0,.622-.341,2.217,2.217,0,0,0,.485-.716,1.715,1.715,0,0,0-.106-1.592,2.509,2.509,0,0,0-1.258-.847l-3.152-1.192-.243.686Zm.574.446a1.24,1.24,0,0,1,.813.078,1.26,1.26,0,0,1,.664.533.767.767,0,0,1,.077.7.759.759,0,0,1-.544.453,1.249,1.249,0,0,1-.838-.116,1.228,1.228,0,0,1-.61-.546.7.7,0,0,1-.042-.669.636.636,0,0,1,.479-.437"
                                          transform="translate(-464.973 -442.128)" fill="#1a1818"/>
                                    <path id="Path_8686" data-name="Path 8686"
                                          d="M525.007,484.771l.272-.791-5.174-1.688-.237.66Z"
                                          transform="translate(-461.344 -427.997)" fill="#1a1818"/>
                                    <path id="Path_8687" data-name="Path 8687"
                                          d="M538.424,456.4a1.522,1.522,0,0,0-.491.33,1.078,1.078,0,0,0-.249.452,1.2,1.2,0,0,0,.327,1.1,2.679,2.679,0,0,0,1.329.836,2.182,2.182,0,0,0,1.518-.026,1.321,1.321,0,0,0,.825-.923,1.068,1.068,0,0,0,.012-.55,1.542,1.542,0,0,0-.266-.564l.4.1.143-.832-3.852-.739-.117.726Zm.63.35a1.425,1.425,0,0,1,.865-.058,1.347,1.347,0,0,1,.767.422.769.769,0,0,1-.31,1.218,1.323,1.323,0,0,1-.859.026,1.4,1.4,0,0,1-.742-.459.7.7,0,0,1-.178-.642.74.74,0,0,1,.458-.507"
                                          transform="translate(-477.123 -404.295)" fill="#1a1818"/>
                                    <path id="Path_8688" data-name="Path 8688"
                                          d="M533.745,423.384a1.28,1.28,0,0,0-.414.392,1.079,1.079,0,0,0-.2.477,1.173,1.173,0,0,0,.435,1.052,2.632,2.632,0,0,0,1.405.653,2.205,2.205,0,0,0,1.507-.219,1.343,1.343,0,0,0,.741-1.013.976.976,0,0,0-.047-.547,1.7,1.7,0,0,0-.366-.529l.414.034.042-.829-5.413-.346-.035.7Zm.679.258a1.33,1.33,0,0,1,.839-.161,1.385,1.385,0,0,1,.828.322.722.722,0,0,1,.262.669.785.785,0,0,1-.416.575,1.328,1.328,0,0,1-.867.136,1.432,1.432,0,0,1-.782-.352.682.682,0,0,1-.231-.62.8.8,0,0,1,.367-.569"
                                          transform="translate(-471.942 -374.945)" fill="#1a1818"/>
                                    <path id="Path_8689" data-name="Path 8689"
                                          d="M547.279,389.339a2.544,2.544,0,0,0-1.528.538,1.316,1.316,0,0,0-.526,1.149,1.431,1.431,0,0,0,.57,1.1,2.468,2.468,0,0,0,1.462.5,2.134,2.134,0,0,0,1.477-.424,1.439,1.439,0,0,0,.6-1.265,1.694,1.694,0,0,0-.256-.871,1.846,1.846,0,0,0-.682-.594l-.352.709a1.011,1.011,0,0,1,.429.771.7.7,0,0,1-.237.625,1.14,1.14,0,0,1-.677.29,23.344,23.344,0,0,0-.088-2.547Zm-.492,2.486a1.254,1.254,0,0,1-.493-.282,1.019,1.019,0,0,1-.244-.559.73.73,0,0,1,.178-.517.962.962,0,0,1,.51-.319,11.809,11.809,0,0,1,.049,1.677"
                                          transform="translate(-483.843 -345.499)" fill="#1a1818"/>
                                    <path id="Path_8690" data-name="Path 8690"
                                          d="M543.792,365.96a1.024,1.024,0,0,0-.132.556.8.8,0,0,0,.369.654,1.166,1.166,0,0,0,.8.208,1.4,1.4,0,0,0,1.154-.862l.146-.283c.133-.254.275-.385.418-.406a.281.281,0,0,1,.225.072.347.347,0,0,1,.106.245.682.682,0,0,1-.1.363l-.308.364.686.445a1.361,1.361,0,0,0,.6-1.219.961.961,0,0,0-.434-.823,1.2,1.2,0,0,0-.918-.192,1.219,1.219,0,0,0-.641.267,2.3,2.3,0,0,0-.493.69l-.159.306a.778.778,0,0,1-.167.253l-.136.062-.183-.062-.078-.188c-.011-.153.1-.345.331-.569l-.688-.375a1.391,1.391,0,0,0-.4.494"
                                          transform="translate(-482.455 -323.964)" fill="#1a1818"/>
                                    <path id="Path_8691" data-name="Path 8691"
                                          d="M533.656,335.012l-.146-.822-1.543.3a5.123,5.123,0,0,1-.8.122,1.147,1.147,0,0,1-.576-.122.482.482,0,0,1-.26-.346.419.419,0,0,1,.064-.321.741.741,0,0,1,.315-.254,6.437,6.437,0,0,1,.891-.259l1.673-.4-.148-.816-2.5.665a1.871,1.871,0,0,0-.951.52.952.952,0,0,0-.267.82.863.863,0,0,0,.207.407,1.459,1.459,0,0,0,.44.358l-1.876.371.13.681Z"
                                          transform="translate(-468.719 -294.71)" fill="#1a1818"/>
                                </g>
                            </svg>
                        </Link>
                    </Col>
                </Row>
                <Row>
                    <Col className='footer-col' sm={3}>
                        <div className="group logo">
                            <p>National Heart Foundation is a health advocacy group and welfare organisation founded in
                                1979 and is located in Dhaka, Bangladesh.</p>
                        </div>

                        <div className="group">
                            <h4>Address</h4>
                            <a target="_blank" href="https://goo.gl/maps/uz77ZBNamQR9yjA89" rel="noreferrer">
                                <p>Plot-7/2, Section-2, Mirpur, Dhaka-1216, Bangladesh</p></a>
                        </div>

                        <div className="group">
                            <h4>Call</h4>
                            <a href={'tel:5805470812'}>58054708-12 </a>
                        </div>

                        <div className="group emails">
                            <h4>Email Us</h4>
                            <a href={'mailto: patientcare@nhf.org.bd'}><p><span>Email:</span> patientcare@nhf.org.bd</p></a>
                        </div>
                    </Col>
                    <Col className='footer-col' sm={{offset: 1}}>
                        <div className="group group-p">
                            <h4>About Us</h4>
                            <ul>
                                <li><Link to={'/about'}>National Heart Foundation of Bangladesh</Link></li>
                                <li><Link to={'/founder'}>The Founder</Link></li>
                                <li><Link to={'/about'}>Objectives</Link></li>
                                <li><Link to={'/our-activities'}>Our Activities</Link></li>
                                <li><Link to={'/executive-council'}>National Executive Council</Link></li>
                                <li><Link to={'/board-of-trustees'}>Board of Trustees</Link></li>
                            </ul>
                        </div>
                    </Col>
                    <Col className='footer-col'>
                        <div className="group group-p">
                            <h4>Affiliated Bodies</h4>
                            <ul>
                                <li><Link to={'/affiliated-body'}>Affiliated Body</Link></li>
                                <li><Link to={'/affiliated-body'}>Affiliated Body List</Link></li>
                                <li><Link to={''}>Affiliated Bodies in Bangladesh (Map)</Link></li>
                            </ul>
                        </div>
                        <div className="group group-p">
                            <h4>NHFB NCD Control & Prevention</h4>
                            <ul>
                                <li><Link to={'/nhf-ccd'}>NHF CCD</Link></li>
                                <li><a href={'https://epidemiology.nhf.org.bd/'} target={'_blank'} rel={'noopener noreferrer'}>Department of Epidemiology and Research</a></li>
                                <li><a href={'https://epidemiology.nhf.org.bd/programs/lsff-advocacy'} target={'_blank'} rel={'noopener noreferrer'}>Prevention of Vitamin A and Vitamin D Deficiency</a></li>
                                <li><a href={'https://epidemiology.nhf.org.bd/programs/road-safety-injury-prevention'} target={'_blank'} rel={'noopener noreferrer'}>Road Safety and Injury Prevention</a></li>
                                <li><a href={'https://epidemiology.nhf.org.bd/programs/salt-reduction'} target={'_blank'} rel={'noopener noreferrer'}>Salt Intake Reduction</a></li>
                                <li><Link to={'/control-prevention/slug?details=transfat-reduction-program'}>Trans-Fat Reduction Program</Link></li>
                                <li><a href={'https://epidemiology.nhf.org.bd/programs/tobacco-control'} target={'_blank'} rel={'noopener noreferrer'}>Tobacco Control Program</a></li>
                                <li><a href={'http://tobacco.nhf.org.bd/'} target={'_blank'} rel={'noopener noreferrer'}>Tobacco Cessation (Online)</a></li>
                                <li><a href={'https://epidemiology.nhf.org.bd/programs/bhci'} target={'_blank'} rel={'noopener noreferrer'}>Hypertension Control Program</a></li>
                            </ul>
                        </div>
                    </Col>
                    <Col className={'footer-col'}>
                        <div className="group group-p">
                            <h4>International Affiliation</h4>
                            <ul>
                                <li><Link to={'/ufat'}>UFAT</Link></li>
                                <li><Link to={'/department'}>Departments</Link></li>
                                <li><Link to={'/conference'}>Conference</Link></li>
                            </ul>
                        </div>
                        <div className="group group-p">
                            <h4>Navigation</h4>
                            <ul>
                                <li><Link to={'/child-heart-details'}>Child's
                                    Heart</Link></li>
                                <li><Link to={'/publications'}>Our Publications</Link></li>
                                <li><Link to={'/contact'}>Contact</Link></li>
                                <li><Link to={'/career'}>Career</Link></li>
                                <li><Link to={'/service-rates'}>Hospital Service Rates</Link></li>
                            </ul>
                        </div>
                    </Col>

                    <Col sm={1} className='footer-col social-menus justify-content-end d-flex'>
                        <ul>
                            <li className='hover'><Link to={'/'}><FaFacebookF/></Link></li>
                            <li className='hover'><Link to={''}><FaTwitter/></Link></li>
                            <li className='hover'><Link to={''}><FaInstagram/></Link></li>
                            <li className='hover'><Link to={''}><FaLinkedinIn/></Link></li>
                            <li className='hover'><Link to={''}><FaYoutube/></Link></li>
                        </ul>
                    </Col>

                </Row>
            </Container>

            <Container className='footer__bottom'>
                <Row>
                    <Col sm={'6'}>
                        <p className={'copy-right'}>{reactHtmlParser('© 2024 National Heart Foundation of Bangladesh.<br>All Rights Reserved.')}</p>
                    </Col>
                    <Col sm={'6'} className={'footer-right'}>
                        <a target="_blank" href="https://www.dcastalia.com/" rel="noreferrer"><p>Designed & Developed
                            by <span>Dcastalia</span></p></a>
                    </Col>
                </Row>
            </Container>
        </StyledFooter>);
};
const StyledFooter = styled.section`
  background-color: #F6F9F8;
  padding: 80px 0 60px 0;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    height: 1px;
    width: 100%;
    left: 0;
    right: 0;
    background-color: #191b1d1a;
    top: 0;
  }

  .footer__top {
    position: relative;
    padding-bottom: 40px;

    &:after {
      content: '';
      position: absolute;
      height: 1px;
      left: 15px;
      right: 15px;
      background-color: rgba(34, 31, 31, 0.20);
      bottom: 0;
    }

    .group {
      margin-bottom: 40px;

      h4 {
        color: #1E1E2E;
        opacity: 70%;
        margin: 0 0 15px 0;
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
      }

      p {
        color: #1E1E2E;
        font-size: 16px;
        line-height: 20px;
        font-weight: 500;
        //text-align: justify;
        transition: color 0.5s ease;
        &:hover{
          color: rgb(231, 46, 75);
          transition: color 0.5s ease;
        }
      }

      a {
        display: flex;
        color: #1E1E2E;
        font-size: 16px;
        line-height: 20px;
        font-weight: 500;
        
      }

      &.emails {
        a {
          text-transform: none;
        }
      }

    }

    .group-p {
      a {
        margin-bottom: 15px;
      }
    }

    .logo {
      img {
        margin-bottom: 40px;
      }
    }

    .social-menus {

      ul {
        li {
          height: 25px;
          width: 25px;
          border-radius: 50%;
          background-color: #1E1E2E;

          margin-bottom: 20px;

          svg {
            color: #ffffff;
            font-size: 11px;
          }

          a {
            position: relative;
            display: flex;
            z-index: 2;
            height: 100%;
            width: 100%;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }

    .footer-col {
      &:not(:last-child,:first-child) {
        margin-right: 30px;
      }
    }
  }

  .footer__bottom {
    padding-top: 20px;

    p {
      color: #1E1E2E;
      font-size: 16px;
      line-height: 20px;
      font-weight: 400;
      transition: color 0.5s ease;
    }
    .copy-right{
      &:hover{
        color: rgb(231, 46, 75);
        transition: color 0.5s ease;
      }
    }

    .footer-right {
      p {
        padding-left: 6%;
        span{
          transition: color 0.5s ease;
        }
        @media (max-width: 767px) {
          padding-left: 0;
          padding-top: 15px;
        }
        &:hover{
          span{
            color: rgb(231, 46, 75);
            transition: color 0.5s ease;
          }
        }
      }
    }
  }


  @media (max-width: 850px) {
    .footer-col {

      min-width: 50%;
      margin: 0;

      &.social-menus {
        justify-content: flex-start !important;

        ul {
          display: flex;

          li {
            margin-right: 10px;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding-bottom: 40px !important;
    .footer__top {
      padding-bottom: 20px;
    }

    .footer__bottom {
      padding-top: 40px;
    }
  }

  @media (max-width: 767px) {
    .social-menus {
      margin-bottom: 20px;
    }

    .footer-col:nth-of-type(1) {
      max-width: 100%;
      min-width: 100%;
    }

    .footer-col:nth-of-type(2), .footer-col:nth-of-type(3) {
      max-width: 50%;
      min-width: 50%;
    }


    padding-top: 60px ;
    .footer-col {
      min-width: 100%;
    }

    .logo {
      width: 80%;
    }
  }

`;


export default React.memo(Footer);